import type { AppliedContract } from '../entities/AppliedContract.js';
import { ContractSupplementDataType, type ContractSupplement } from '../entities/ContractSupplement.js';

// we only need to look into ag2, as ag1 is always active on the base contract
export function checkIfChangeIsMadeOnTemporarySupplement(
  appliedContract: AppliedContract,
  appliedDate: Date,
): null | ContractSupplement {
  const initalChangeForAddingAG2 = appliedContract.history?.paths?.find(
    pathHistory =>
      pathHistory.path === 'agEingruppierung2.agVertragsInfos.taetigkeit' &&
      pathHistory.changes?.at(0)?.type === ContractSupplementDataType.NULL,
  );

  if (!initalChangeForAddingAG2) return null;

  const supplement = appliedContract.supplements?.find(sup => sup._id === initalChangeForAddingAG2.supplementID);

  if (!supplement) return null;

  // only return a supplement if the supplement change
  if (
    supplement.endDateAG2 &&
    supplement.startDateAG2 &&
    appliedDate <= supplement.endDateAG2 &&
    appliedDate >= supplement.startDateAG2
  ) {
    return supplement;
  }

  return null;
}
